var map = {
	"./grace/guest.png": "fb80",
	"./grace/login.png": "605d",
	"./grace/main.png": "8f95",
	"./grace/register.png": "0ef9",
	"./meadow/slide.svg": "5e3b",
	"./meadow/slide2.svg": "795d",
	"./meadow/slide3.svg": "f8f0",
	"./meadow/slide4.svg": "0111",
	"./meadow/slide5.svg": "468e",
	"./pickup/app1.png": "ea01",
	"./pickup/app2.png": "f7a3",
	"./screentime/designDiagram.jpg": "2f97",
	"./screentime/progressScreens.png": "6aba",
	"./screentime/resultsScreen.png": "5a77",
	"./wayward/comboScreens.png": "2cc4",
	"./wayward/gameplay1.png": "719c",
	"./wayward/gameplay2.png": "7f6c",
	"./wayward/mainmenu.png": "611c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c46f";